/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import CloseAction from './CloseAction/index'
import Comms from './Comms/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import PreviewDocument from 'DesignSystem/PreviewDocument/index'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/FilesEdit/Content",
  onSubmit
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let messageParamsDocumentIdValueData = fromData.useDataValue({ viewPath,
context: 'message',
path: 'params.document_id',
})
let selectedSubmitData = fromData.useDataSubmit({ viewPath,
context: 'selected',
})
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 paddingBottom={dtSpaceM}
 paddingLeft={0}
 paddingRight={0}
 dangerouslyBypassFocusLock={true}
 height="95%"
 width="95%"
>
{childProps => (
<React.Fragment>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--pl-1-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pr-2-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h3"
 color={dtColorsNeutral900}
 marginBottom={dtSpaceS}
 text="Edit letter"
/>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
/>
</div>
<PreviewDocument
{...childProps}
  viewPath={`${viewPath}/PreviewDocument`}
 overflowY="auto"
 data="message.params.document_id"
 documentId={messageParamsDocumentIdValueData}
 data="selected"
 onSubmit={selectedSubmitData}
/>
<Comms
{...childProps}
  viewPath={`${viewPath}/Comms`}
/>
</React.Fragment>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}